import { useMemo } from 'react'
import { ChainId, GelatoLimitOrders } from '@gelatonetwork/limit-orders-lib'
import { useNetwork } from 'wagmi'
import { GELATO_HANDLER , getChainId } from 'config/constants/exchange'
import { useEthersSigner } from 'hooks/useEthersProvider'

const useGelatoLimitOrdersLib = (): GelatoLimitOrders | undefined => {
  const library = useEthersSigner()
  const { chain } = useNetwork()
  const chainId = getChainId(chain);

  return useMemo(() => {
    if (!chainId || !library) {
      console.error('Could not instantiate GelatoLimitOrders: missing chainId or library')
      return undefined
    }
    try {
      return new GelatoLimitOrders(chainId as ChainId, library?.getSigner(), GELATO_HANDLER, false)
    } catch (error: any) {
      console.error(`Could not instantiate GelatoLimitOrders: ${error.message}`)
      return undefined
    }
  }, [chainId, library])
}

export default useGelatoLimitOrdersLib
